// @core/api/endpoints/landing/update_sections.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingPageResponse,
  UpdateSectionsRequest,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Update page sections
 * Replaces all sections of a page. Used for batch editing: reordering, adding, removing, and modifying sections in one call.
 */
export async function UpdateSections(
  page_id: string,
  data: UpdateSectionsRequest,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id/sections`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.put<LandingPageResponse>(requestPath, data, requestOptions);
}
